import { render } from "./Token.vue?vue&type=template&id=f70ec29e&bindings={\"token\":\"props\"}"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"

import "./Token.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script